<script>
export default {
    sign_in_with: 'Iniciar sesión con',
    or_sign_in_with_credentials: 'O inicia sesión con tus credenciales',
    sign_up_with: 'Regístrate con',
    generic_error: 'Ha ocurrido un error. Por favor, inténtalo más tarde.',
    i_agree_with_the: 'Acepto los ',
    we_have_sent_you_an_email: 'Te hemos enviado un correo electrónico :-)',
    email: 'Correo electrónico',
    password: 'Contraseña',
    lost_your_password: '¿Perdiste tu contraseña?',
    recovery_here: 'recupérala aquí',
    sign_in: 'Iniciar sesión',
    forgot_password: '¿Olvidaste tu contraseña?',
    create_new_account: 'Crear nueva cuenta',
    terms_of_service: 'Términos de servicio',
    link_privacy: 'Política de privacidad',
    term_conditions_text: 'Al registrarte o iniciar sesión con uno de los servicios mencionados arriba, aceptas nuestros {link_terms} y reconoces nuestra {link_privacy}, que describe cómo gestionamos tus datos personales.',
    about_us: 'Sobre nosotros',
    blog: 'Blog',
    mit_license: 'Licencia MIT',
    docs: 'Documentos',
    loading: 'Cargando',
    dashboard: 'Panel',
    add_new_entry: 'Agregar nueva entrada',
    add_new_model: 'Agregar nuevo modelo',
    my_entries: 'Mis entradas',
    search_entries: 'Buscar entradas',
    payee_list: 'Lista de deudas',
    planned_entries: 'Entradas planificadas',
    budgets: 'Presupuestos',
    settings: 'Configuración',
    logout: 'Cerrar sesión',
    expenses: 'Gastos',
    incoming: 'Ingresos',
    transfer: 'Transferencia',
    debit: 'Deudas',
    choose_one_of_currently_tags: 'Elige una de las etiquetas actuales',
    choose_a_wallet_to_transfer_to: 'Elige una billetera a la que transferir',
    choose_wallet_account: 'Elige cuenta de la billetera',
    choose_wallet_to_transfer: 'Elige una billetera a la que transferir',
    payment_confirg: 'Confirmar pago',
    choose_an_option: 'Elige una opción',
    choose_a_model: 'Elige un modelo',
    out_of_wallet: 'Fuera de la billetera',
    insert_new_tag_name: 'Introduce nuevo nombre de etiqueta',
    add_here_your_note: 'Agrega aquí tu nota',
    insert_new_entry: 'Introduce nueva entrada',
    show_planned_entries: 'Mostrar entradas planificadas',
    show_more: 'Mostrar más',
    restore: 'Restaurar',
    reasume_of_all_entries: 'Resumen de todas las entradas',
    list_of_all_payees: 'Lista de todas las deudas',
    forget_debit: 'Olvidar débito',
    date_start: 'Fecha de inicio',
    debit_name: 'Nombre de la deuda',
    date_end: 'Fecha de fin',
    choose_frequency: 'Elige una frecuencia',
    choose_method: 'Elige un método',
    insert_new_planned_entry: 'Introduce nueva entrada planificada',
    create_new_budget: 'Crear nuevo presupuesto',
    budget_name: 'Nombre del presupuesto',
    period: 'Periodo',
    budget: 'Presupuesto',
    account: 'Cuenta',
    category: 'Categoría',
    label: 'Etiqueta',
    labels: 'Etiquetas',
    entry_type: 'Tipo de entrada',
    enable_email_notification: 'Habilitar notificación por correo',
    save_budget: 'Guardar presupuesto',
    add_new_wallet: 'Agregar nueva billetera',
    show_archived: 'Mostrar archivados',
    wallet_settings: 'Configuración de billetera',
    category_settings: 'Configuración de categoría',
    add_new_category: 'Agregar nueva categoría',
    category_name: 'Nombre de la categoría',
    save_changes: 'Guardar cambios',
    archive_label: 'Archivar etiqueta',
    add_model_entry: 'Agregar nueva entrada de modelo',
    model_settings: 'Configuración de modelo',
    set_your_default_currency: 'Establece tu moneda predeterminada',
    currency_settings: 'Configuración de moneda',
    wallets: 'Billeteras',
    models: 'Modelos',
    categories: 'Categorías',
    currency: 'Moneda',
    profile: 'Perfil',
    assistance: 'Asistencia',
    my_entry: 'Mi entrada',
    is_planned: 'Planificados',
    add: 'Agregar',
    model: 'Modelo',
    wallet: 'Billetera',
    payee: 'Beneficiario',
    frequency: 'Frecuencia',
    method: 'Método',
    amount: 'Monto',
    date: 'Fecha',
    tag: 'Etiqueta',
    tags: 'Etiquetas',
    note: 'Nota',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    confirm: 'Confirmar',
    delete: 'Eliminar',
    edit: 'Editar',
    show: 'Mostrar',
    hide: 'Ocultar',
    archive: 'Archivar',
    unarchive: 'Desarchivar',
    search: 'Buscar',
    search_labels: 'Buscar etiquetas...',
    or_insert_new_tag_name: 'O ingresa un nuevo nombre de etiqueta',
    show_details: 'Mostrar detalles',
    bounce_rate: 'Tasa de rebote',
    session_duration: 'Duración de la sesión',
    amount_before: 'Monto anterior',
    send_a_request: 'Enviar una solicitud',
    change_order: 'Cambiar orden',
    add_new_workspace: 'Agregar nuevo espacio de trabajo',
    set_up_your_workspaces: 'Configura tus espacios de trabajo',
    choose_parent_category: 'Elige una categoría principal',
    exclude_from_stats: 'Excluir de las estadísticas',
    label_color: 'Color de la etiqueta',
    choose_currency: 'Elige una moneda',
    choose_wallet_type: 'Elige un tipo de billetera',
    payment_deadline: 'Fecha límite de pago',
    credit_card_installment: 'Cuota de tarjeta de crédito',
    wallet_color: 'Color de la billetera',
    workspace_settings: 'Configuración del espacio de trabajo',
    default_currency: 'Moneda predeterminada',
    default_payment_type: 'Tipo de pago predeterminado',
    share_workspace_with: 'Compartir espacio de trabajo con',
    share: 'Compartir',
    remove: 'Eliminar',
    workspace_shared_with: 'Espacio de trabajo compartido con',
    choose_a_category: 'Elige una categoría',
    payment_confirm: 'Confirmar pago',
    my_planned: 'Planificados',
    my_health: 'Salud financiera',
    workspace: 'Espacio de trabajo',
    entry_saved: 'Entrada guardada correctamente',
    could_not_log_in: 'No se pudo iniciar sesión',
    send_my_password: 'Enviar nueva contraseña',
    recovery_your_password: 'Recupera tu contraseña',
    name: 'Nombre',
    confirm_password: 'Confirmar contraseña',
    privacy_policy: 'Privacidad y política',
    create_account: 'Crear una nueva cuenta',
    click_here: 'Haz clic aquí',
    save_template: 'Guardar modelo',
    set_new_password: 'Establecer nueva contraseña',
    account_created: 'Cuenta creada con éxito, verifica tu correo electrónico para confirmar y activar tu cuenta',
    search_by_text: 'Buscar por texto',
    no: 'NO',
    yes: 'SÍ',
    date_interval: 'Intervalo de fechas',
    type_of_transaction: 'Tipo de transacción',
    choose_period: 'Elige un periodo',
    daily: 'Diario',
    weekly: 'Semanal',
    monthly: 'Mensual',
    yearly: 'Anual',
    one_shot: 'Única vez',
    recursive: 'Recurrente',
    or_nsert_new_tag_name: 'O introduce un nuevo nombre de etiqueta',
    no_budgets_found: 'No se encontraron presupuestos',
    list_of_entries_of: 'Lista de entradas de',
    no_payees_found: 'No se encontraron deudas',
    list_of_all_budgets: 'Lista de todos los presupuestos',
    list_of_all_planned_entries: 'Lista de todas las entradas planificadas',
    set_your_default_currecny: 'Establece tu moneda predeterminada',
    update: 'Actualizar',
    stats: 'Estadísticas',
    payment_types: 'Tipos de pago',
    create_new_debit: 'Crear nueva deuda',
    months: {
        jan: 'Ene',
        january: 'Enero',
        feb: 'Feb',
        february: 'Febrero',
        mar: 'Mar',
        march: 'Marzo',
        apr: 'Abr',
        april: 'Abril',
        may: 'May',
        jun: 'Jun',
        june: 'Junio',
        jul: 'Jul',
        july: 'Julio',
        aug: 'Ago',
        august: 'Agosto',
        sep: 'Sep',
        september: 'Septiembre',
        oct: 'Oct',
        october: 'Octubre',
        nov: 'Nov',
        november: 'Noviembre',
        dec: 'Dic',
        december: 'Diciembre',
    },
    closing_account_statement: 'Cierre de estado de cuenta',
    account_payment: 'Cuenta de pago',
    start_date: 'Fecha de inicio',
    end_date: 'Fecha de fin',
    show_entries: 'Mostrar entradas',
    wallet_name: 'Nombre de la billetera',
    balance_wallet: 'Saldo de la billetera',
    wallet_type: 'Tipo de billetera',
    next_execution_time: 'Próxima fecha de ejecución',
    end_time: 'Fecha de fin',
    no_data_found: 'No se encontraron datos',
    average_incoming: 'Ingresos promedio',
    average_savings: 'Ahorros promedio',
    your_planned_expenses: 'Gastos planificados',
    average_expenses: 'Gastos promedio',
    list_of_voices: 'Lista de entradas',
    no_voices_found: 'No se encontraron entradas',
    workspace_whared_with: 'Espacio de trabajo compartido con',
    user_not_found: 'Usuario no encontrado',
    save_as_model: 'Guardar como modelo',
    write_temlate_name: 'Escribe el nombre del modelo',
    end_of_month: 'Previsión fin de mes',
    ticket_value: 'Valor del vale',
    spent: 'gastado',
    remaining: 'restante',
    planned: 'planificado',
    no_entries_found: 'No se encontraron entradas',
    credit_card_installement: 'Cuota de tarjeta de crédito',
    choose_planned_type: 'Elige un tipo planificado',
    list_of_all_credit_cards: 'Lista de todas las tarjetas de crédito',
    details: 'Detalles',
    planned_entry: 'Planificados',
    back_to_login: 'Volver al inicio de sesión',
    workspace_name: 'Nombre de tu espacio de trabajo',
    first_wallet_name: 'Nombre de tu primera billetera',
    wallet_amount: 'Saldo de la billetera',
    setup_account: 'Configurar cuenta',
    donate: 'Donar',
    faq: 'FAQ',
    start_Date: 'Fecha de inicio',
    savings: 'Ahorros',
    paid_debits: 'Deudas',
    given_on_loan: 'Prestado',
    loans: 'Préstamos',
    goals: 'Objetivos',
    list_of_all_goals: 'Lista de todos los objetivos',
    no_goals_found: 'No se encontraron objetivos',
    add_new_goal: 'Agregar nuevo objetivo',
    target_amount: 'Monto',
    goal_name: 'Nombre del objetivo',
    goal_target: 'Fecha objetivo',
    goal_note: 'Notas',
    icons: {
        house: 'Casa',
        car: 'Coche',
        travel: 'Viaje',
        education: 'Educación',
        health: 'Salud',
        savings: 'Ahorros',
        retirement: 'Jubilación',
        business: 'Negocios',
        charity: 'Caridad',
        family: 'Familia',
        hobby: 'Pasatiempo',
        investment: 'Inversión',
        emergency: 'Emergencia',
        vacation: 'Vacaciones',
        home_improvement: 'Renovación',
        technology: 'Tecnología',
        pets: 'Mascotas',
        other: 'Otro',
    },
    goal_type: 'Tipo de objetivo',
    activity: 'Actividad',
    deposit: 'Depósito',
    saved: 'Ahorrado',
    my_goal: 'Mi objetivo',
    my_goals: 'Mis objetivos',
    current_saved: 'Actualmente ahorrado',
    monthly_deposit: 'Depósito mensual',
    due_date: 'Fecha de vencimiento',
    description: 'Descripción',
    choose_a_goal: 'Selecciona un objetivo',
    withdrawal: 'Retiro',
    choose_payment_type: 'Elige tipo de pago',
    no_goals_available: 'No hay objetivos disponibles',
    create_goal_to_start_saving: 'Crea un objetivo para empezar a ahorrar',
    create_first_goal: 'Crea tu primer objetivo',
    operation_type: 'Tipo de operación',
    attention: 'Atención',
    choose_payee: 'Elige beneficiario',
    insert_payee_name: 'Introduce nombre del beneficiario',
    wallets_must_be_different: 'Las billeteras deben ser diferentes',
    create_goal_first: 'Crea primero un objetivo',
    label_input_hint: 'Puedes agregar varias etiquetas separándolas con espacios',
    no_models_available: 'No hay modelos disponibles',
    create_first_model: 'Crea tu primer modelo',
    your_goal: 'Tu objetivo',
    confirm_delete_goal: 'Confirmar eliminación de objetivo',
    remaining_expenses: 'Gastos restantes',
    wallet_management: 'Gestión de billetera',
    wallet_management_description: 'Gestiona tus billeteras, agrega nuevas y establece tu billetera predeterminada.',
    add_first_wallet: 'Agrega tu primera billetera',
    no_wallets_available: 'No hay billeteras disponibles',
    create_first_wallet: 'Crea tu primera billetera',
    archived: 'Archivado',
    last_updated: 'Última actualización',
    active_wallets: 'Billeteras activas',
    all_wallets: 'Todas las billeteras',
    archived_wallets: 'Billeteras archivadas',
    last_update: 'Última actualización',
    click_to_create_wallet: 'Haz clic para crear una billetera',
    add_wallet: 'Agregar billetera',
    credit_card_settings: 'Configuración de tarjeta de crédito',
    voucher_settings: 'Configuración de vale',
    additional_options: 'Opciones adicionales',
    enter_initial_balance: 'Introduce saldo inicial',
    edit_wallet: 'Editar billetera',
    initial_balance: 'Saldo inicial',
    label_settings: 'Configuración de etiquetas',
    manage_your_labels: 'Gestiona tus etiquetas, agrega nuevas o archiva las que no uses',
    add_new_label: 'Agregar nueva etiqueta',
    edit_label: 'Editar etiqueta',
    add_label: 'Agregar etiqueta',
    label_name: 'Nombre de la etiqueta',
    active_labels: 'Etiquetas activas',
    all_labels: 'Todas las etiquetas',
    archived_labels: 'Etiquetas archivadas',
    no_labels_found: 'No se encontraron etiquetas',
    balance: 'Saldo',
    active: 'Activo',
    manage_your_workspaces: 'Gestiona tus espacios de trabajo.',
    edit_workspace: 'Editar espacio de trabajo',
    user_shared: 'Usuario compartido',
    enter_email: 'Introduce el correo electrónico',
    no_workspaces_found: 'No se encontraron espacios de trabajo',
    reset: 'Restablecer',
    category_details: 'Detalles de la categoría',
    expenses_by_category_monthly: 'Gastos por categoría (mensual)',
    expenses_by_category_comparison: 'Gastos por categoría (comparación)',
    manage_your_models: 'Gestiona tus modelos, agrega nuevos o archiva los que no uses',
    write_template_name: 'Introduce el nombre del modelo',
    sort_name_asc: 'Nombre (A-Z)',
    sort_name_desc: 'Nombre (Z-A)',
    sort_amount_desc: 'Cantidad (Alta-Baja)',
    sort_amount_asc: 'Cantidad (Baja-Alta)',
    notification_emails: 'Correos de notificación',
    notification_thresholds: 'Umbrales de notificación',
    notification_threshold_example: 'Ej: 60 para 60%',
}
</script>